import axios from "axios";
import { getToken, removeToken } from "@/lib/local";
import { Message } from "element-ui";
import { showLoading, endLoading } from "./loading";

const AUTH_ERROR_URLS = ["/v1/admin/cmn/admin/info"];

const isAuthError = error => {
  const status = error && error.response && error.response.status;
  const requestUrl = error && error.config && error.config.url;

  if (status === 401) {
    return true;
  }

  return (
    status === 403 &&
    AUTH_ERROR_URLS.some(url => requestUrl && requestUrl.includes(url))
  );
};

class AjaxRequest {
  constructor() {
    // this.baseURL = "http://adminkeji.jubaosmart.com/";
    console.log(process.env, "/api");
    // this.baseURL = '/api'
    process.env.NODE_ENV !== "production"
      ? (this.baseURL = "https://test.rbbaotong.com")
      : (this.baseURL = "https://api.rbbaotong.com");
    console.log(process.env, this.baseURL, process.env.VUE_APP_BASE_URL);
    this.headers = {};
    this.timeout = 5000;
    console.log(process.env);
  }
  request(options) {
    let instance = axios.create();
    this.setInterceptor(instance);
    let config = this.merge(options);
    // console.log(config)
    if (config.url == "/res/file/upload") {
      if (process.env.NODE_ENV !== "production") {
        config.baseURL = "https://test.rbbaotong.com";
      } else {
        config.baseURL = "https://api.rbbaotong.com";
      }
    }
    config.timeout = 300000;
    if (options.platform === "ChannelManage") {
      config.headers.Platform = "ChannelManage";
    }
    if (options.appkey) {
      config.headers.AppKey = "BpLnfgDs";
    }
    return instance(config);
  }
  merge(config) {
    return {
      ...config,
      baseURL: this.baseURL,
      timeout: this.timeout,
      headers: { ...this.headers, ...config.headers }
    };
  }
  setInterceptor(instance) {
    instance.interceptors.request.use(config => {
      showLoading();

      let token = getToken("jubao_admin");
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }

      return config;
    });
    instance.interceptors.response.use(
      res => {
        endLoading();

        let data = res.data;
        if (data.err_code !== 0 && data.err_code !== 1108) {
          Message({
            message: data.err_msg,
            type: "error",
            duration: 3 * 1000
          });
        } else {
          return data;
        }
      },
      error => {
        endLoading();
        if (isAuthError(error)) {
          removeToken("jubao_admin");
          window.location.reload();
          return Promise.reject(error);
        }

        if (error.response && error.response.status === 403) {
          const message =
            (error.response.data && error.response.data.err_msg) ||
            "暂无权限访问当前功能";
          Message({
            message,
            type: "error",
            duration: 3 * 1000
          });
          return Promise.reject(error);
        }

        // 统一处理 网络错误
        Message({
          message: "网络错误",
          type: "error",
          duration: 3 * 1000
        });

        return Promise.reject(error);
      }
    );
  }
}

export default new AjaxRequest();
